import { render, staticRenderFns } from "./c-expand-btn.vue?vue&type=template&id=798e7ef1&"
import script from "./c-expand-btn.vue?vue&type=script&lang=js&"
export * from "./c-expand-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports